document.addEventListener("DOMContentLoaded", function() {
  var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-bg[data-bg]"));

  // Apply the background only once the image is fully downloaded and decoded,
  // so it never renders progressively. `is-loaded` lets CSS fade it in.
  function loadBackground(lazyBackground) {
    let lazyUrl = lazyBackground.dataset.bg;
    if (lazyUrl.includes("https://jfaprod300924.s3.amazonaws.com/media/https://jfaprod300924.s3.amazonaws.com/media/")) {
      lazyUrl = lazyUrl.replace("https://jfaprod300924.s3.amazonaws.com/media/https://jfaprod300924.s3.amazonaws.com/media/", "https://jfaprod300924.s3.amazonaws.com/media/");
    }
    lazyBackground.classList.remove("lazy-bg");

    const show = function() {
      lazyBackground.style.backgroundImage = 'url(' + lazyUrl + ')';
      lazyBackground.classList.add("is-loaded");
    };
    const img = new Image();
    img.src = lazyUrl;
    img.decode().then(show, show);
  }

  if ("IntersectionObserver" in window) {
    let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          loadBackground(entry.target);
          lazyBackgroundObserver.unobserve(entry.target);
        }
      });
    });

    lazyBackgrounds.forEach(function(lazyBackground) {
      lazyBackgroundObserver.observe(lazyBackground);
    });
  } else {
    lazyBackgrounds.forEach(loadBackground);
  }
});
